const MEDIA = '/v1/media';
const STORY_GROUPS = '/v1/story-groups';
const STORY_SEGMENTS = '/v1/story/segments';

const API_ENDPOINT = {
  auth: {
    login: '/v1/login',
    /** Exchanges a refresh token for a fresh pair. Body is `{ token }`, not `{ refreshToken }`. */
    refresh: '/v1/refresh',
  },
  media: {
    list: MEDIA,
    create: MEDIA,
    uploadUrl: `${MEDIA}/upload-url`,
    item: (id: string) => `${MEDIA}/${id}`,
  },
  story: {
    groups: STORY_GROUPS,
    group: (id: string) => `${STORY_GROUPS}/${id}`,
    publish: (id: string) => `${STORY_GROUPS}/${id}/publish`,
    disable: (id: string) => `${STORY_GROUPS}/${id}/disable`,
    activate: (id: string) => `${STORY_GROUPS}/${id}/activate`,
  },
  audience: {
    segments: STORY_SEGMENTS,
    segment: (id: string) => `${STORY_SEGMENTS}/${id}`,
  },
};

export default API_ENDPOINT;
